module.exports = __webpack_public_path__ + "static/media/header.57c6d5bc.png";